import { Link } from 'react-router-dom';

export default function Shops() {
	return (
		<div>
			店舗一覧（未実装）<br />
		</div>
	);
}
